import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface DeliveryStatsDTO {
  total: number;
  queued: number;
  sent: number;
  delivered: number;
  viewed: number;
  unsent: number;
  optOut: number;
  bounces: number;
  complaints: number;
}

export class DeliveryStats {
  readonly isDeliveryStatsDeliveryStats: boolean = true;

  readonly total: number;
  readonly queued: number;
  readonly sent: number;
  readonly delivered: number;
  readonly viewed: number;
  readonly unsent: number;
  readonly optOut: number;
  readonly bounces: number;
  readonly complaints: number;


  constructor(
  total: number, 
  queued: number, 
  sent: number, 
  delivered: number, 
  viewed: number, 
  unsent: number, 
  optOut: number, 
  bounces: number, 
  complaints: number
  ) {
    this.total = total;
    this.queued = queued;
    this.sent = sent;
    this.delivered = delivered;
    this.viewed = viewed;
    this.unsent = unsent;
    this.optOut = optOut;
    this.bounces = bounces;
    this.complaints = complaints;
  }

  static fromDTO(dto: DeliveryStatsDTO): DeliveryStats {
    const total = getInt32(dto, "total", InvalidDeliveryStatsTotalError);
    const queued = getInt32(dto, "queued", InvalidDeliveryStatsQueuedError);
    const sent = getInt32(dto, "sent", InvalidDeliveryStatsSentError);
    const delivered = getInt32(dto, "delivered", InvalidDeliveryStatsDeliveredError);
    const viewed = getInt32(dto, "viewed", InvalidDeliveryStatsViewedError);
    const unsent = getInt32(dto, "unsent", InvalidDeliveryStatsUnsentError);
    const optOut = getInt32(dto, "optOut", InvalidDeliveryStatsOptOutError);
    const bounces = getInt32(dto, "bounces", InvalidDeliveryStatsBouncesError);
    const complaints = getInt32(dto, "complaints", InvalidDeliveryStatsComplaintsError);
    return new DeliveryStats(
      total,
      queued,
      sent,
      delivered,
      viewed,
      unsent,
      optOut,
      bounces,
      complaints
    );
  }

  toDTO(): DeliveryStatsDTO {
    const dto: DeliveryStatsDTO = {
        total: this.total,
        queued: this.queued,
        sent: this.sent,
        delivered: this.delivered,
        viewed: this.viewed,
        unsent: this.unsent,
        optOut: this.optOut,
        bounces: this.bounces,
        complaints: this.complaints
    };
    return dto;
  }
  }

DeliveryStats.prototype.toString = function toString(): string {
  return `DeliveryStats(total='${this.total}',queued='${this.queued}',sent='${this.sent}',delivered='${this.delivered}',viewed='${this.viewed}',unsent='${this.unsent}',optOut='${this.optOut}',bounces='${this.bounces}',complaints='${this.complaints}')`;
};

export class InvalidDeliveryStatsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsError";
  }
}
export class InvalidDeliveryStatsTotalError extends InvalidDeliveryStatsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsTotalError";
  }
}

export class InvalidDeliveryStatsQueuedError extends InvalidDeliveryStatsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsQueuedError";
  }
}

export class InvalidDeliveryStatsSentError extends InvalidDeliveryStatsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsSentError";
  }
}

export class InvalidDeliveryStatsDeliveredError extends InvalidDeliveryStatsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsDeliveredError";
  }
}

export class InvalidDeliveryStatsViewedError extends InvalidDeliveryStatsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsViewedError";
  }
}

export class InvalidDeliveryStatsUnsentError extends InvalidDeliveryStatsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsUnsentError";
  }
}

export class InvalidDeliveryStatsOptOutError extends InvalidDeliveryStatsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsOptOutError";
  }
}

export class InvalidDeliveryStatsBouncesError extends InvalidDeliveryStatsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsBouncesError";
  }
}

export class InvalidDeliveryStatsComplaintsError extends InvalidDeliveryStatsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDeliveryStatsComplaintsError";
  }
}
